import { styled } from '@mui/material/styles'
import React from 'react'
import { TextField, TextFieldProps } from 'react-admin'
import {
  BriefStatus,
  SupplierStatus,
  EventItem,
} from 'services/api/entities/events/types/internal/event-models'
import { useKRecordContext } from 'services/hooks/useKRecordContext'

const PREFIX = 'BriefAndSupplyStatusField'

const classes = {
  red: `${PREFIX}-red`,
  black: `${PREFIX}-black`,
  green: `${PREFIX}-green`,
}

const StyledTextField = styled(TextField)({
  [`& .${classes.red}`]: { color: 'red' },
  [`& .${classes.black}`]: { color: 'black' },
  [`& .${classes.green}`]: { color: 'green' },
})

type Source = 'briefStatus' | 'supplierStatus'

type Props = {
  source: Source
  label: string
} & TextFieldProps

type Color = 'red' | 'black' | 'green'

const briefColorsMap: Record<BriefStatus, Color> = {
  missing: 'red',
  completed: 'black',
  accepted: 'green',
}
const supplierColorsMap: Record<SupplierStatus, Color> = {
  unassigned: 'red',
  assigned: 'black',
  confirmed: 'green',
}

const BriefAndSupplyStatusField: React.FC<Props> = (props) => {
  const record = useKRecordContext<EventItem>()
  const { source } = props

  const briefColorKey = record?.briefStatus ?? 'missing'
  const supplierColorKey = record?.supplierStatus ?? 'unassigned'

  const colorStatus: Color =
    source === 'briefStatus'
      ? briefColorsMap[briefColorKey]
      : supplierColorsMap[supplierColorKey]

  return (
    <StyledTextField {...props} sortable={false} sx={{ color: colorStatus }} />
  )
}

export default BriefAndSupplyStatusField
